export default {"src":"https://s.sylndr.com/c-fd0c3a5/_next/static/media/specialInspection.03662770.svg","height":84,"width":104,"blurWidth":0,"blurHeight":0};